var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirgahayuBannerLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 77,
    viewBox: "0 0 107 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 68H85.5",
    stroke: "#DDD7D7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92 68H106",
    stroke: "#DDD7D7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5546 20.6532C81.5546 20.6532 62.9685 17.8769 40.8591 22.9532C31.063 25.2023 19.4708 28.5513 10.1809 34.0756V41.5001C19.1399 36.8612 29.1749 33.4118 40.8591 31.8349C51.2815 30.4283 64.6498 28.4236 78.461 28.4236C87.0789 28.4236 100.337 30.4283 100.337 30.4283C100.337 30.4283 95.6601 26.8483 92.8241 25.2532C88.9066 23.0498 81.5546 20.6532 81.5546 20.6532Z",
    fill: "#DDD7D7",
    stroke: "#DDD7D7",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3024 44.4158C10.3024 44.4158 6.71365 44.3822 5.29096 43.9442C3.69944 43.4543 3.20218 43.066 2.30237 42.4158L2.27788 37.0594L3.74982 36.5683C3.74982 36.5683 5.52015 37.6378 7.03821 38.2312C8.21697 38.692 10.2617 38.7718 10.2617 38.7718L10.3024 44.4158Z",
    fill: "#9D1516"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32178 41.1966C4.48276 40.5554 2.68164 39.4155 2.68164 39.4155L2.41628 42.9055C2.41628 42.9055 2.8476 43.4397 5.15586 44.1167C7.46412 44.7936 10.2795 45.0077 10.2795 45.0077L10.507 42.0163C10.507 42.0163 8.07075 41.8065 6.32178 41.1966Z",
    fill: "#F5F3F3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0074 11.0381C45.1295 12.682 35.5613 13.0882 19.0857 19.5778C11.5838 22.5327 5.91962 26.689 2.15755 30.0696L2.15755 43.0907C6.50223 40.0275 13.266 36.9549 19.0754 34.9482C39.4315 27.9167 55.2272 26.4074 71.9614 25.4744C87.1268 24.6288 103.642 28.0503 103.642 28.0503C103.642 28.0503 98.6229 24.2433 94.2315 22.4385C90.5725 20.9348 83.9171 19.1055 83.9171 19.1055C83.9171 19.1055 87.7246 16.9385 90.1769 15.7854C94.7053 13.6561 102.751 11.8846 102.751 11.8846C102.751 11.8846 78.7934 9.58653 63.0074 11.0381Z",
    fill: "#FF0003",
    stroke: "#FF0003",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.338 21.0326C30.7313 23.3067 18.136 26.718 8.19228 32.4034C6.27314 33.5007 4.20103 35.0369 2.30249 36.5859V43.0972C3.6041 42.1916 5.11878 41.2624 6.86645 40.363C16.8102 35.2462 28.3691 31.7184 41.338 28.9922C50.6188 27.0413 68.2035 24.882 83.1015 25.5809C91.1814 25.96 104.315 28.4236 104.315 28.4236C104.315 28.4236 99.3626 24.8839 96.3598 23.3068C92.2118 21.1281 84.4273 18.7584 84.4273 18.7584C84.4273 18.7584 64.7479 16.0134 41.338 21.0326Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30249 30.4158C3.30249 30.4158 2.40053 30.8343 5.54057 28.4236C7.73987 26.7352 11.5068 24.4438 11.5068 24.4438",
    stroke: "#CD0204",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5623 11.9356C60.5623 11.9356 70.115 11.2699 75.8093 11.3671C82.0266 11.4733 91.7192 11.9357 91.7192 11.9357",
    stroke: "#CD0204",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3709 13.0728C94.3709 13.0728 90.6221 14.2675 88.4047 15.3469C86.7812 16.1373 84.4272 17.6211 84.4272 17.6211",
    stroke: "#9D1516",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4949 25.0123C72.4949 25.0123 79.6236 24.5618 85.0902 25.0122C90.5568 25.4627 96.3598 26.1493 96.3598 26.1493",
    stroke: "#DFDADA",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1468 36.3794C13.1468 36.3794 18.799 32.9721 36.5686 28.9954C49.9561 25.9993 60.2487 25.5849 60.2487 25.5849",
    stroke: "#DFDADA",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8024 17.9155C89.8024 17.9155 92.4393 16.6708 94.3024 15.9155C98.9994 14.0115 102.802 13.4155 102.802 13.4155",
    stroke: "#FF0003",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80249 27.4155C2.80249 27.4155 5.4679 25.1768 7.30249 23.9155C11.3025 21.1655 14.3025 19.9155 14.3025 19.9155",
    stroke: "#FF0003",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3024 18.4155L21.3024 16.9155",
    stroke: "#FF0003",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8024 15.9155L26.8024 14.9155",
    stroke: "#FF0003",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30249 45.416C2.30249 45.416 3.78237 46.161 4.80249 46.416C6.80249 46.916 8.30249 46.916 8.30249 46.916",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M7 62C7 62 8 66.1164 11.5 70C16.4568 75.5 21.5 75.5 21.5 75.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14 59C14 59 15.3155 62.199 18 64.5C21.5 67.5 24.5 67.5 24.5 67.5",
    stroke: "#DDD7D7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28 76H58.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69 76H82",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirgahayuBannerLeft);
export default __webpack_public_path__ + "static/media/dirgahayu_banner_left.2353fa4d7af41ffddb5d36930cd2d471.svg";
export { ForwardRef as ReactComponent };